import CustomRoleFormPage from "./custom-role-form-page.jsx";

export default CustomRoleFormPage;
